"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _styles = require("@material-ui/core/styles");

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _FadeIn = _interopRequireDefault(require("@jobmatchme/ui/es/components/FadeIn"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "classes", "onClose"];

var Transition = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slide.default, (0, _extends2.default)({
    direction: "up",
    ref: ref
  }, props));
});
/**
 * A simple ModalDialog that renders a backdrop based container
 * @param {Children}  children        The modals content
 * @param {objects}   dialogActions   The actions content. For example Buttons
 * @param {Title}     string          The modals title text
 * @param {titleCenter}     boolean   The modals title text align center
 * @param {boolean}   open            Whether the modal is open or not
 * @param {boolean}   showDividers    Is dividers showed or not
 * @param {number}    opacity         The opacity of the backdrop
 * @param {void}      onClose         Callback when the modal is beeing closed
 * @param {string}    verticalMobilePosition   Dialog position on mobile view: top, middle, bottom
 * @param {boolean}   oneOff          Whether the dialog is shown once
 * @param {String}    name            Name of dialog
 */


// Root Config and Close Button position
var muiStyles = function muiStyles(theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
};

var DialogTitle = (0, _styles.withStyles)(muiStyles)(function (props) {
  var children = props.children,
      classes = props.classes,
      onClose = props.onClose,
      other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogTitle.default, (0, _extends2.default)({
    disableTypography: true,
    className: classes.root
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      variant: "h6",
      children: children
    }), onClose ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      "aria-label": "close",
      className: classes.closeButton,
      onClick: onClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
    }) : null]
  }));
});

var ModalDialog = function ModalDialog(_ref) {
  var id = _ref.id,
      header = _ref.header,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      children = _ref.children,
      titleCenter = _ref.titleCenter,
      showDividers = _ref.showDividers,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.5 : _ref$opacity,
      dialogActions = _ref.dialogActions,
      _ref$oneOff = _ref.oneOff,
      oneOff = _ref$oneOff === void 0 ? false : _ref$oneOff,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'modalDialog' : _ref$name,
      _ref$mobileHeight = _ref.mobileHeight,
      mobileHeight = _ref$mobileHeight === void 0 ? '85%' : _ref$mobileHeight,
      _ref$verticalMobilePo = _ref.verticalMobilePosition,
      verticalMobilePosition = _ref$verticalMobilePo === void 0 ? 'middle' : _ref$verticalMobilePo;
  var theme = (0, _styles.useTheme)();
  var positionBottom = (0, _useMediaQuery.default)(theme.breakpoints.down('xs')) && verticalMobilePosition === 'bottom'; // Determine where the dialog should be located
  // if using a mobile view

  var borderRadius = '16px'; // Help function for position detection

  var dialogPos = verticalMobilePosition;

  var getVal4Mobile = function getVal4Mobile(dialogPos, cssPos, unit) {
    return positionBottom ? cssPos === 'top' && dialogPos === 'top' ? 0 : cssPos === 'bottom' && dialogPos === 'bottom' ? 0 : unit : unit;
  };

  var isAllreadyViewed = function isAllreadyViewed(name) {
    return oneOff && window && localStorage.getItem(name);
  };

  var closing = function closing() {
    if (oneOff && window) localStorage.setItem(name, 'true');
    onClose();
  };

  var Dialog = (0, _styles.withStyles)({
    paperFullScreen: {
      margin: 0,
      width: '100%',
      height: mobileHeight,
      transition: 'all 0.5s ease',
      borderBottomLeftRadius: getVal4Mobile(dialogPos, 'bottom', borderRadius),
      borderBottomRightRadius: getVal4Mobile(dialogPos, 'bottom', borderRadius),
      borderTopLeftRadius: getVal4Mobile(dialogPos, 'top', borderRadius),
      borderTopRightRadius: getVal4Mobile(dialogPos, 'top', borderRadius)
    },
    paper: {
      borderRadius: borderRadius,
      overflowY: header ? 'visible !important' : 'auto'
    },
    scrollPaper: {
      alignItems: positionBottom ? 'flex-end' : 'center'
    }
  })(_Dialog.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Dialog, {
    id: id,
    onClose: closing,
    fullScreen: positionBottom,
    className: "".concat(_styleModule.default.modalContainer),
    open: !isAllreadyViewed(name) && open,
    "aria-labelledby": "customized-dialog",
    "aria-describedby": "customized-description",
    TransitionComponent: positionBottom ? Transition : undefined,
    BackdropProps: {
      style: {
        backgroundColor: "rgba(0, 0, 0, ".concat(opacity, ")")
      }
    },
    children: [header && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.header,
      children: header
    }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogTitle, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "".concat(_styleModule.default.headline, " ").concat(titleCenter ? _styleModule.default.center : ''),
        children: title
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.default, {
      className: _styleModule.default.content,
      dividers: showDividers ? true : false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.default, {
        delay: 300,
        transition: 0.5,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          component: "div",
          gutterBottom: true,
          children: children
        })
      })
    }), dialogActions && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogActions.default, {
      className: "".concat(_styleModule.default.actions, " ").concat(noPadding ? _styleModule.default.noPadding : ''),
      children: dialogActions
    })]
  });
};

var _default = ModalDialog;
exports.default = _default;